// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__afd {
  display: flex;
  flex-direction: column;
  gap: var(--ring-unit);
}

.linkIcon__cbe {
  align-self: center;
}
`, "",{"version":3,"sources":["webpack://./src/modules/ai/common/badge/configure-ai-popup-message.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ring-unit);\n}\n\n.linkIcon {\n  align-self: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__afd`,
	"linkIcon": `linkIcon__cbe`
};
export default ___CSS_LOADER_EXPORT___;
